import { createSlice } from '@reduxjs/toolkit';
import type { ErrorMessageCodes } from './error-message-codes';
import { ModalState } from './modal-state';

export type BankIdSlice = {
    qrData?: string | null;
    errorCode?: ErrorMessageCodes | null;
    modalState: ModalState;
    autoStartToken?: string | null;
    bankIdOrderRef?: string | null;
    contactSsn?: string | null;
    organizationNumber?: string | null;
    purpose: string | null;
    memberId: number | null;
};

const initialState: BankIdSlice = {
    qrData: null,
    errorCode: null,
    modalState: ModalState.CLOSED,
    autoStartToken: null,
    bankIdOrderRef: null,
    contactSsn: null,
    organizationNumber: null,
    purpose: null,
    memberId: null
};

export const bankIdSlice = createSlice({
    name: 'BankId',
    initialState,
    reducers: {
        reset: () => {
            return { ...initialState };
        },
        completed: (state) => {
            return { ...state, modalState: ModalState.COMPLETED };
        },
        setError: (state, { payload }) => {
            return {
                ...state,
                errorCode: payload,
                modalState: ModalState.ERROR
            };
        },
        inProgress: (state, { payload }) => {
            return {
                ...state,
                autoStartToken: payload.autoStartToken || state.autoStartToken,
                bankIdOrderRef: payload.bankIdOrderRef || state.bankIdOrderRef,
                contactSsn: payload.contactSsn || state.contactSsn,
                organizationNumber:
                    payload.organizationNumber || state.organizationNumber,
                qrData: payload.qrData
            };
        },
        startAuth: (state, { payload }) => {
            return {
                ...state,
                ...initialState, // Reset any previous BankID verification
                purpose: payload.purpose,
                memberId: payload.memberId || null,
                modalState: ModalState.IN_PROGRESS
            };
        },
        close: (state) => {
            return {
                ...state,
                modalState: ModalState.CLOSED
            };
        }
    }
});

export const { reset, completed, setError, inProgress, startAuth, close } =
    bankIdSlice.actions;

export default bankIdSlice.reducer;
